import React from 'react';
import './profileCard.css'; // Link to CSS file
import { FaFacebookF, FaWhatsapp, FaInstagram, FaPinterestP, FaYoutube, FaGlobe, FaDownload } from 'react-icons/fa';
import { BsInstagram, BsDownload } from 'react-icons/bs';
import logo from '../../assets/images/laftahLogo.png'
import { MdEmail } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import axios from 'axios';
import { MdPhone } from "react-icons/md";



const recipes = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/LaftahApp',
    icon: <FaFacebookF className="icon" />,
  },
  {
    name: 'Whatsapp',
    url: 'https://wa.me/963989444610',
    icon: <FaWhatsapp className="icon" />,
  },
   {
    name: 'Instagram',
    url: 'https://www.instagram.com/laftah_app/',
    icon: <FaInstagram className="icon" />,
  },
  {
    name: 'Download App',
    url: null, // No link yet, or put download link here
    icon: <FiDownload className="icon" />,
  },
];


export const ProfileCard = () => {
  const [statusRequest, setStatusRequest] = useState(0);//0:none,1:loading,2:pauseDownload(make the button grey)
  const [is64, setIs64Bit] = useState(false);
  const [is32, setIs32Bit] = useState(false);
  const [isunKnown, setIsunKnown] = useState(false);
  const [isCompleteGet, setIsCompleteGet] = useState(false);
  const [showManualOptions, setShowManualOptions] = useState(false);
  // const [source, setSource] = useState("ads_qr"); 
  useEffect(() => {
    const initiateDownload = () => {


      const ua = navigator.userAgent || "";
      const platform = navigator.platform || "";
      const full = (ua + " " + platform).toLowerCase();

      const dashVariants = "[-‐‑‒–—]";
      const is64 = new RegExp(`arm64|win64|aarch64|armv8|sm${dashVariants}?938b|sm${dashVariants}?8650|sm${dashVariants}?8550|sm${dashVariants}?8450|sm${dashVariants}?a566b|sm${dashVariants}?s938b|exynos2100|exynos2200|tensor|unisoc_t618`).test(full);
      const is32 = /armv7|arm32|armeabi|i386|i686|\bx86(?!_64)\b|mt6580|mt6735|mt6737|sc7731|unisoc_sc9832|spreadtrum|sm[-_]?j(100|110|120|200|210|220|320|500|510|530|570|700|710)|sm[-_]?g570|sm[-_]?g53[0-2]|grand|huawei[-_ ]?mya|y5|lenovo[-_ ]?a1000/i.test(full);


      // If either userAgent or platform says 32-bit → definitely false
      if (is32) {
        setIs32Bit(true);
      }
      // Else if both userAgent and platform say 64-bit → true
      else if (is64) {
        setIs64Bit(true);
      }
      else {
        setIsunKnown(true);
      }
      setIsCompleteGet(true);
    };

    // initiateDownload();
  }, []);
  const downloadFile = async ({ architecture } = {}) => {
    const search = window.location.search;
    const rawParams = search.slice(1).split("&"); 


    const values = rawParams.map(param => {
      const [key, value] = param.split("=");
      return value !== undefined ? value : key;
    });

    const source = values[0];     
    const extraParam1 = values[1];
    const extraParam2 = values[2]; 

    console.log("source =", source);
    console.log("extraParam1 =", extraParam1);
    console.log("extraParam2 =", extraParam2);

     console.log(is64);
    try {
      const res = await axios.get("https://cms.laftah.sss-sy.net/appversion/api/v1/download", {
        params: {
          file_version: architecture !== undefined?architecture:is64 ? "v8a" :is32? "v7a":'',
           source: "ads_qr",
           f_sub_source: extraParam1,
           s_sub_source:extraParam2,

        },
        // responseType: 'blob'
      });
      console.log(res.data);
      if (isCompleteGet) {
        if (res.status === 200 || res.status === 201) {
          const a = document.createElement("a");
          // a.href = 'https://cms.laftah.sss-sy.net'+res.data['file_url'];
          a.href = res.data['file_url'];
          a.download = "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else if (res.data.message !== "No version available for download.") {
          toast.error("لا يوجد إصدار متاح للتنزيل");
        } else if (res.data.error !== null) {
          toast.error('❌ حدث خطأ ما');
        }
      } else {
        toast.error('⏳ انتظر قليلاً ثم حاول مجددًا');
      }

    } catch (err) {
      toast.error('❌ حدث خطأ ما');
    }
  }
    const downloadInstaller= async () => {
      const search = window.location.search;
      const rawParams = search.slice(1).split("&"); 


      const values = rawParams.map(param => {
        const [key, value] = param.split("=");
        return value !== undefined ? value : key;
      });

      const source = values[0];     
      const extraParam1 = values[1];
      const extraParam2 = values[2]; 

      console.log("source =", source);
      console.log("extraParam1 =", extraParam1);
      console.log("extraParam2 =", extraParam2);

      setStatusRequest(1);//loading
     console.log(is64);
    try {
      const res = await axios.get("https://cms.laftah.sss-sy.net/appversion/api/v1/download", {
        params: {
          // file_version: architecture !== undefined?architecture:is64 ? "v8a" :is32? "v7a":'',
           source: "ads_qr",
           f_sub_source: extraParam1,
           s_sub_source:extraParam2,

        },
        // responseType: 'blob'
      });
      console.log(res.data);
      // if (isCompleteGet) {
        if (res.status === 200 || res.status === 201) {
          const a = document.createElement("a");
          // a.href = 'https://cms.laftah.sss-sy.net'+res.data['file_url'];
          a.href = res.data['file_url'];
          a.download = "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          const newStatus = 2;
          setStatusRequest(newStatus);
          console.log('loveeee');
        } else if (res.data.message !== "No version available for download.") {
          setStatusRequest(0);
          toast.error("لا يوجد إصدار متاح للتنزيل");
        } else if (res.data.error !== null) {
          setStatusRequest(0);
          toast.error('❌ حدث خطأ ما');
        }
      // } else {
      //   toast.error('⏳ انتظر قليلاً ثم حاول مجددًا');
      // }

    } catch (err) {
      setStatusRequest(0);
      toast.error('❌ حدث خطأ ما');
    }
  }
  const handleClickDownload = () => {
  // console.log(isCompleteGet);
  // console.log(isunKnown);
  // if (!isCompleteGet) {
  //   toast.info("⏳ الرجاء الانتظار حتى يتم تحديد نوع الجهاز...");
  //   return;
  // }

  // if (!isunKnown) {
  //   downloadFile();
  // } else {
  //   setShowManualOptions(true);
  // }
  downloadInstaller();
};
  return (
    <div>
    <div className="profile-page">
      <div className="card">
        <img src={logo} alt="Profile" className="profile-image" />
        <h2 className="name">هديّة من القلب إلى القلب</h2>

        <div className="social-icons">
          
          <a href="https://www.laftahapp.com" target="_blank" rel="noopener noreferrer">
            <FaGlobe className="icon" />
          </a>
          <a
            href="mailto:info@laftahapp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MdEmail className="icon" />
          </a>
        </div>
       <div className="contact-buttons">
  <a href="tel:0998764825" className="contact-btn">
    <MdPhone className="contact-btn-icon" />
    <span>0998764825</span>
  </a>

  <a href="tel:0989882602" className="contact-btn">
    <MdPhone className="contact-btn-icon" />
    <span>0989882602</span>
  </a>
</div>
        <div className="recipes">
  {recipes.map((recipe, i) => {
    const isDownloadApp = recipe.name === 'Download App';
    const isBusy = statusRequest === 1 || statusRequest === 2; // preparing or downloading

    if (recipe.url != null) {
      return (
        <a
          key={i}
          href={recipe.url}
          target="_blank"
          rel="noopener noreferrer"
          className="recipe-card"
        >
          {recipe.icon}
          <span>
            {isDownloadApp && statusRequest === 1
              ? 'Preparing...'
              : isDownloadApp && statusRequest === 2
              ? 'Downloading...'
              : recipe.name}
          </span>
        </a>
      );
    } else {
      return (
        <div
          key={i}
          className={`recipe-card ${isDownloadApp && isBusy ? 'disabled' : ''}`}
          onClick={!isBusy ? handleClickDownload : undefined} // disable click when busy
          style={{ cursor: isBusy ? 'not-allowed' : 'pointer' }}
        >
          {recipe.icon}
          <span>
            {isDownloadApp && statusRequest === 1
              ? 'Preparing...'
              : isDownloadApp && statusRequest === 2
              ? 'Downloading...'
              : recipe.name}
          </span>
        </div>
      );
    }
  })}
</div>

      </div>
    </div>
     {(showManualOptions) ? (
  <div className="overlay">
    <div className="manual-download">
      <p className="download-parh">Select the appropriate version:</p>
      <div className="download-buttons">
        <button onClick={() => downloadFile({ architecture: "v7a" })}>
          📱 32-bit version
        </button>
        <button onClick={() => downloadFile({ architecture: "v8a" })}>
          📱 64-bit version
        </button>
      </div>
      <button className="back-button" onClick={() => setShowManualOptions(false)}>
        Back
      </button>
    </div>
  </div>
):(<div></div>)}

  </div>
  );
};
